import React from "react";
import { GenderEnum } from "../../frontend/admin/src/libs/apiClient";

export interface App {
	user: {
		roles: string[];
	};
}

export enum Status {
	NOT_AVAILABLE = "N/A",
}

export enum ClubType {
	PARTNER = "partner",
	NON_PARTNER = "nonpartner",
}

export enum Role {
	CLUB_MANAGER = "ROLE_CLUB_MANAGER",
	RECRUITER = "ROLE_RECRUITER",
	ADMIN = "ROLE_ADMIN",
	COACH = "ROLE_COACH",
}
export interface GeneralResponse {
	status: string;
	message: string;
}

export enum APIResponse {
	SUCCESS = "success",
	FAILED = "failed",
	ERROR = "error",
}

export interface GameDetail {
	isMobile: boolean;
	mobileData: { [key: string]: string };
	game: Game;
	eventTypes: { [key: string]: string };
	beproEvents: BeproEvent[];
	highlights: Highlight[];
	video?: Video;
	awayUnknownLogo?: AwayUnknownLogo;
	highlightSubmitted: boolean;
	homeTeamEditLink: string;
	awayTeamEditLink: string;
	homeTeamEditable: boolean;
	awayTeamEditable: boolean;
	userId: number;
	gameOptions: GameOptions;
	homePlayers: any[];
	awayPlayers: any[];
	gameDescriptionTrans: string;
	gameClips: [];
	mercureUrl: string;
	roles: string[];
	userActivityLink: string;
	clubId: number;
	bestGame?: {
		playPlayerGameId: number;
	};
	disableResync: boolean;
	hasDetailedEvents: boolean;
	homeTeamStartsOnLeft: boolean | null;
}
export interface GameOptions {
	ai: boolean;
	statistics_rating: boolean;
	statistics_players: boolean;
	statistics_teams: boolean;
	events: boolean;
	downloadable: boolean;
	downloadable_gametags: boolean;
	clips: boolean;
	clips_across_games: boolean;
}

export interface AwayUnknownLogo {
	filePath: string;
}

export interface Game {
	team_category: string;
	id: number;
	homeClub: Club;
	homeTeam: Team;
	awayTeam: Team;
	highlights: Highlight[];
	category: string;
	description: string;
	type: string;
	date: string;
	veoLink?: string | null;
	lineup: Lineup;
	isAnalysisFinished: boolean | null;
	analysisApproved: boolean;
	analysisNotApprovedReason: string | null;
	providerTag: string | null;
	gameVideoInfo: gameVideoInfo[];
	pole_id: number;
	isNational: boolean;
	ownerships: { value: number; label: string }[];
	leagueId: number | null;
	leagueName: string | null;
	competitionEditionId?: number | null;
	competitionEditionLabel?: string | null;
	gender: GenderEnum | null;
}

export const AllGenderOptions = (Object.keys(GenderEnum.Values) as Array<keyof typeof GenderEnum>).map((key) => ({
	label: key,
	value: key,
}));

export interface gameVideoInfo {
	event_period: string;
	padding: number;
	start_match_time: number;
	end_match_time: number;
	start_video_time?: number;
	end_video_time?: number;
	formal_length?: number;
	base_half?: boolean;
}

export interface Team {
	id: number;
	clubName: string;
	clubId: number;
	teamName: string;
	teamCategory: string;
	score: number | null;
	composition: string;
	colorShirt: string;
	colorShort: string;
	team?: {
		slug: string;
		category: string;
		name: string;
		coach: {
			id: number;
		};
	};
	beproTeam: number;
	club: Club;
	players: any[];
	clubNonpartner: {
		id: number;
		logo: string | undefined;
		name: string;
		country?: string | null;
	};
	type: string;
	team_id: number;
	team_category: string;
	team_name: string;
	clubType: string;
}

export interface Club {
	id: number;
	name: string;
	logo: string;
	country: string;
}

export interface Highlight {
	id?: number;
	timestamp: number;
	title: string;
	note: string;
	authorId: number;
	userId: number;
}

export interface Video {
	streamAvailable: boolean;
	mp4available: boolean;
	id: number;
	dir: string;
	ai: string;
	custom_source: boolean;
	isDownloadable: boolean;
	presetVersion: string | null;
	folder: string;
	baseUri: string;
}

export interface Lineup {
	[key: string]: LineupPlayer;
}

export interface LineupPlayer {
	id: number;
	game_player_id: number;
	team_id: number;
	position: null | string;
	player_id: number;
	back_number: number;
	player_name: string;
	playerName?: string;
	position_name: string;
	player_last_name: string;
	is_starting_lineup: boolean;
}

export interface BeproEvent {
	repeats: number;
	additional_events: BeproEvent[];
	id: number;
	game_id: number;
	game_team_id: number;
	game_player_id: number;
	provider_event_id: number;
	event_time: number;
	event_time_padding: number;
	event_time_calculated?: number;
	event_period: EventPeriod;
	x: number;
	y: number;
	event_type: string;
	ball_position_x: number | null;
	ball_position_y: number | null;
	relative_event_id?: number | null;
	relative_event_time?: number | null;
	relative_event_player_id?: number | null;
	relative_event_x?: number | null;
	relative_event_y?: number | null;
	subEventType?: null | string;
	event_video_time: number | null;
	relativeSubstitution?: BeproEvent;
}
export interface Players {
	YOB?: string;
	goal?: null;
	id?: number;
	numberSign?: number;
	playerId?: number;
	playerName?: string;
	playerNonPartnerId?: null;
	position?: string;
	rating?: number;
	substitute?: false;
	teamId?: number;
	clubType?: string;
}

export interface GeneralResponseForGameClipEvents {
	id: number;
	status: string;
	message: string;
	data: GameClipEventsValue;
	latest_id?: number;
	maximum_clip_exceeded_id?: number;
	clip_link?: string;
}
export interface GameClipEventsValue {
	"0"?: MyClipsClipSubData;
	clip?: number;
	clip_link?: string;
	clipName?: string;
	event: ClipData[];
	beproEvent?: ClipData[];
	beproEventCount?: number;
	id?: number;
	isFinished?: boolean | null | number;
	errorCode?: number;
	name?: string;
	clipId?: number;
	overwrite?: boolean;
	maximum?: boolean;
	expireLinkAt?: string;
	shareSlug?: string;
	description?: string;
	password?: string;
	expireDate?: string;
	isPasswordUpdated?: number;
	url?: string;
	isPasswordEnabled?: number;
	deletedAt?: string | null;
	createdAt?: string;
	updatedAt?: string | null;
}

export interface MyClipsClipSubData {
	clip_link?: string;
	clipName?: string;
	beproEvent?: Array<BeproEvent | number>;
	id?: number;
	isFinished?: boolean | null | number;
	name?: string;
	clipId?: number;
	overwrite?: boolean;
	maximum?: boolean;
	expireLinkAt?: string;
	shareSlug?: string;
	password?: string;
	expireDate?: string;
	isPasswordUpdated?: number;
	url?: string;
	isPasswordEnabled?: boolean;
	deletedAt?: string | null;
	createdAt?: string;
	updatedAt?: string | null;
}
export interface ClipData {
	source?: number;
	position?: number;
	start?: number;
	end?: number;
	beproEventId?: number;
}
export interface AddVideoStat {
	event?: number;
	ended?: boolean;
	started?: boolean;
}

export enum EventPeriod {
	FirstHalf = "FIRST_HALF",
	SecondHalf = "SECOND_HALF",
	ExtraHalfOne = "EXTRA_HALF_ONE",
	ExtraHalfTwo = "EXTRA_HALF_TWO",
	ExtraHalfThree = "EXTRA_HALF_THREE",
}
export enum ResponseMessage {
	MAXIMUM_CLIPS_EXCEEDED = "Maximum Clips Exceeded",
	GAME_CLIP_ALREADY_EXIST = "Game clip already exists",
}

export enum EventTypes {
	SetPiece = "Set Piece",
	Pass = "Pass",
	Duel = "Duel",
	Shot = "Shot",
	PassReceived = "Pass Received",
	Interception = "Interception",
	TakeOn = "Take-On",
	Carry = "Carry",
	Clearance = "Clearance",
	Recovery = "Recovery",
	Foul = "Foul",
	FoulWon = "Foul Won",
	ControlUnderPressure = "Control Under Pressure",
	Intervention = "Intervention",
	Substitution = "Substitution",
	AerialClearance = "Aerial Clearance",
	Block = "Block",
	Goal = "Goal",
	GoalScored = "Goal Scored",
	OwnGoal = "Own Goal",
	Manual = "manual",
	Clips = "clips",
}

export enum SubEventTypes {
	RedCard = "Red Card",
	YellowCard = "Yellow Card",
	Freekick = "Freekick",
	Corner = "Corner",
	Aerial = "Aerial",
	Foul = "Foul",
	PenaltyKick = "Penalty Kick",
	Ground = "Ground",
	ThrowIn = "Throw-In",
	Off = "Off",
	On = "On",
	GoalKick = "Goal Kick",
}

export type HighlightFormValues = Partial<Highlight>;

export interface EditScoreFormValues {
	homeScore: number;
	awayScore: number;
}

export interface GameAnalysisApprovalValues {
	approvalStatus: "approved" | "disapproved" | "";
	reason?: string;
}
export interface GameAnalysisResyncValues {
	resyncAfter: string;
	syncLocally: boolean;
	resyncType: string;
}

export interface GameDescriptionValue {
	description: string;
}
export interface PlayerStatsData {
	homeTeam: PlayerStats;
	awayTeam: PlayerStats;
}

export interface PlayerStats {
	playerStat: PlayerStat[];
	goalkeeperStat: GoalkeeperStat[];
	distributionStat: DistributionStat[];
	offensiveStat: OffensiveStat[];
	defensiveStat: DefensiveStat[];
}

export interface PlayerStat {
	no?: number;
	playerName?: string;
	backNumber?: number;
	position?: string;
	rating: number;
	minutesPlayed: number;
	goalsScrored: number;
	assists: number;
	offsides: number;
	shots: number;
	freekicks: number;
	corners: number;
	throwIns: number;
	fouls: number;
	yellowCards: number;
	redCards: number;
}

export interface GoalkeeperStat {
	no?: number;
	playerName?: string;
	backNumber?: number;
	position?: string;
	goalsConceded: number;
	catches: number;
	punches: number;
	goalsKicksSuccess: number;
	goalsKicksTotal: number;
	aerialClearancesSuccess: number;
	aerialClearancesTotal: number;
}

export interface DistributionStat {
	no?: number;
	playerName?: string;
	backNumber?: number;
	position?: string;
	passesSuccess: number;
	passesTotal: number;
	passAccuracy: number;
	keyPasses: number;
	passesInFinalThirdSuccess: number;
	passesInFinalThirdTotal: number;
	passesInMiddleThirdSuccess: number;
	passesInMiddleThirdTotal: number;
	passesInDefensiveThirdSuccess: number;
	passesInDefensiveThirdTotal: number;
	longPassesSuccess: number;
	longPassesTotal: number;
	mediumRangePassesSuccess: number;
	mediumRangePassesTotal: number;
	shortPassesSuccess: number;
	shortPassesTotal: number;
	passesForwardSuccess: number;
	passesForwardTotal: number;
	passesSidewaysSuccess: number;
	passesSidewaysTotal: number;
	passesBackwardSuccess: number;
	passesBackwardTotal: number;
	crossesSuccess: number;
	crossesTotal: number;
	controlUnder: number;
}

export interface OffensiveStat {
	no?: number;
	playerName?: string;
	backNumber?: number;
	position?: string;
	shotsOnTarget: number;
	blockedShots: number;
	shotsOffTarget: number;
	shotsInsidePa: number;
	shotsOutsidePa: number;
	takeOnsSuccessful: number;
	takeOnsTotal: number;
}
export interface DefensiveStat {
	no?: number;
	playerName?: string;
	backNumber?: number;
	position?: string;
	tacklesSuccess: number;
	tacklesTotal: number;
	aerialDuelsSuccess: number;
	aerialDuelsTotal: number;
	groundDuelsSuccess: number;
	groundDuelsTotal: number;
	interceptions: number;
	clearances: number;
	interventions: number;
	recoveries: number;
	blocks: number;
	mistakes: number;
	foulsWon: number;
}

export interface PlayerStatTable {
	no?: number;
	playerName?: string;
	backNumber?: number;
	position?: string;
	rating?: number;
	minutesPlayed?: number;
	goalsScrored?: number;
	assists?: number;
	goalsOwn: number;
	offsides?: number;
	shots?: number;
	freekicks?: number;
	corners?: number;
	throwIns?: number;
	fouls?: number;
	yellowCards?: number;
	redCards?: number;
	goalsConceded?: number;
	catches?: number;
	punches?: number;
	goalsKicksSuccess?: number;
	goalsKicksTotal?: number;
	aerialClearancesSuccess?: number;
	aerialClearancesTotal?: number;
	passesSuccess?: number;
	passesTotal?: number;
	passAccuracy?: number;
	keyPasses?: number;
	passesInFinalThirdSuccess?: number;
	passesInFinalThirdTotal?: number;
	passesInMiddleThirdSuccess?: number;
	passesInMiddleThirdTotal?: number;
	passesInDefensiveThirdSuccess?: number;
	passesInDefensiveThirdTotal?: number;
	longPassesSuccess?: number;
	longPassesTotal?: number;
	mediumRangePassesSuccess?: number;
	mediumRangePassesTotal?: number;
	shortPassesSuccess?: number;
	shortPassesTotal?: number;
	passesForwardSuccess?: number;
	passesForwardTotal?: number;
	passesSidewaysSuccess?: number;
	passesSidewaysTotal?: number;
	passesBackwardSuccess?: number;
	passesBackwardTotal?: number;
	crossesSuccess?: number;
	crossesTotal?: number;
	controlUnderPressure?: number;
	shotsOnTarget?: number;
	blockedShots?: number;
	shotsOffTarget?: number;
	shotsInsidePa?: number;
	shotsOutsidePa?: number;
	takeOnsSuccessful?: number;
	takeOnsTotal?: number;
	tacklesSuccess?: number;
	tacklesTotal?: number;
	aerialDuelsSuccess?: number;
	aerialDuelsTotal?: number;
	groundDuelsSuccess?: number;
	groundDuelsTotal?: number;
	interceptions?: number;
	clearances?: number;
	interventions?: number;
	recoveries?: number;
	blocks?: number;
	mistakes?: number;
	foulsWon?: number;
}

export interface TeamStatsData {
	homeTeam: TeamStats;
	awayTeam: TeamStats;
}
export interface TeamStats {
	teamStat: TeamStat;
	distributionStat: DistributionStat;
	offensiveStat: OffensiveStat;
	defensiveStat: DefensiveStat;
}
export interface TeamStat {
	goals: number;
	possession: number;
	shots: number;
	shotsOnTarget: number;
	fouls: number;
	offsides: number;
	freeKicks: number;
	corners: number;
	averageRating: number;
}

export enum TeamStatsType {
	SUMMARY = "summary",
	OFFENSIVE = "offensive",
	DEFENSIVE = "defensive",
	DISTRIBUTION = "distribution",
}

type PropsWithChildren<P> = P & { children?: React.ReactNode | undefined };

export type FC<P = {}> = FunctionComponent<P>;

interface FunctionComponent<P = {}> {
	(props: PropsWithChildren<P>, context?: any): React.ReactElement<any, any> | null;
	propTypes?: React.WeakValidationMap<P> | undefined;
	contextTypes?: React.ValidationMap<any> | undefined;
	defaultProps?: Partial<P> | undefined;
	displayName?: string | undefined;
}

export type VFC<P = {}> = VoidFunctionComponent<P>;

interface VoidFunctionComponent<P = {}> {
	(props: P, context?: any): React.ReactElement<any, any> | null;
	propTypes?: React.WeakValidationMap<P> | undefined;
	contextTypes?: React.ValidationMap<any> | undefined;
	defaultProps?: Partial<P> | undefined;
	displayName?: string | undefined;
}

export interface DatagridTable {
	addUpdateGameAnalysisLink: string;
	getGameAnalysisLink: string;
	loadDropDownDataLink: string;
	loadDataLink: string;
	updateVipStatusLink: string;
	updateHiddenStatusLink: string;
	updateHiddenForScoutStatusLink: string;
	updateAnalyseStatusLink: string;
	updateScoreLink: string;
	updateGameLink: string;
	addGameLink: string;
	loadPoleLink: string;
	checkClubNameAlreadyExists: string;
	getMatchingPartnerNonPartnerClubs: string;
	deleteGameLink: string;
	loadEditGameDataLink: string;
	searchAwayClubsLink: string;
	searchNationalLeaguesLink: string;
	loadAwayTeamLink: string;
	loadClubListLink: string;
	loadHomeTeamLink: string;
	loadCompetitionEditionsLink: string;
	loadGameOwnerShips: string;
	roles: string[];
	userId: number;
	clubId: number;
	ignoreColumns: [];
	preferredOrder: {};
	programGame: {
		status: boolean;
		homeClubId: number;
		homeClubType: string;
	};
	npClub?: boolean;
	categories: Record<string, string>;
	gameAnalyzeRequestDefaultPriority: number;
	userRolePermissions: { permission: string; resource: string }[];
	isSuperAdmin: boolean;
}
export interface DatagridTableColumns {
	koraStatsFinished: boolean;
	ubitrackFinished: boolean;
	beproFinished: boolean;
	sportlogiqFinished: boolean;
	id?: number;
	country?: string;
	date?: {
		date: string;
		timezone: string;
		timezone_type: number;
	};
	homeTeam?: DatagridTableTeam;
	awayTeam?: DatagridTableTeam;
	category?: string;
	team_category?: string;
	team_name?: string;
	matchLink?: string;
	score?: {
		homeTeamScore: number;
		awayTeamScore: number;
	} | null;
	edit?: string;
	edit_matchsheet?: string;
	edit_score?: string;
	hidden?: string;
	hiddenForScout?: string;
	upload?: string;
	discover?: boolean;
	analysisRequestedAt?: {
		date: string;
		timezone: string;
		timezone_type: number;
	};
	vip?: string;
	isAnalysisFinished?: boolean;
	isAnalysisApproved?: boolean;
	video?: number;
	veoLink?: string | null;
	gender?: string | null;
	ownerships?: {}[];
	isTeamsheetFullyFinished: boolean;
	analyse?: {
		bepro: { status: boolean };
		ubitrack: { status: boolean };
		koraStats: { status: boolean };
		sportlogiq: { status: boolean };
		physStat: { status: boolean };
	};
}
export interface DatagridTableTeam {
	clubId: number;
	name: string;
	clubName: string;
	club: {
		id: number;
		name: string;
		logoFile: {
			pathname: string;
		};
		logo: string;
	};
}

export enum ColumnType {
	TEXT = "text",
	DATE = "date",
	SELECT = "select",
	TRISTATE = "tristate",
}

export enum TableHeader {
	COUNTRY = "COUNTRY",
	SCORE = "SCORE",
	TEAM = "TEAM",
	TEAMSHEET = "TEAMSHEET",
	PAGE = "PAGE",
	CLUB = "CLUB",
	OPPONENT = "OPPONENT",
	HIDDEN_GAME = "HIDDEN GAME",
	STAT = "STAT",
	STAT_APPROVED = "STAT APPROVED",
	TEAM_GENDER = "Team Gender",
}

export enum Continents {
	ANTARCTICA = "antarctica",
	SOUTH_AMERICA = "southAmerica",
	NORTH_AMERICA = "northAmerica",
	OCEANIA = "oceania",
	EUROPE = "europe",
	ASIA = "asia",
	AFRICA = "africa",
	NATIONAL_CONTINENTS = "nationalContinents",
}

export enum InputType {
	Text = "text",
	Password = "password",
}

export enum GameTeam {
	Home = "home",
	Away = "away",
}

export enum GameTagDownloadOption {
	SELECTED_EVENT = "SELECTED_EVENT",
	ALL_EVENTS = "ALL_EVENTS",
}

export enum UserDownloadActivityTags {
	VIDEO = "video",
	GAME_CLIP = "game_clip",
}

export enum UserDownloadActivityKeys {
	GAME_ID = "gameId",
	CLIP_ID = "clipId",
}

export interface Halves {
	firstHalfStart: number;
	firstHalfEnd: number;
	secondHalfStart: number;
	secondHalfEnd: number;
	extraHalfOneStart: number;
	extraHalfOneEnd: number;
	extraHalfTwoStart: number;
	extraHalfTwoEnd: number;
	extraHalfThreeStart: number;
	extraHalfThreeEnd: number;
}

export enum Resource {
	PRODUCT_MANAGEMENT = "product_management",
	POLES = "poles",
	POLE = "pole",
	NON_PARTNER_CLUBS = "non_partner_clubs",
	NON_PARTNER_CLUB = "non_partner_club",
	NON_PARTNER_PLAYERS = "non_partner_players",
	NON_PARTNER_PLAYER = "non_partner_player",
	ROLES_PERMISSIONS_MANAGEMENT = "roles_permissions_management",
	ROLE_PERMISSION_MANAGEMENT = "role_permission_management",
	ADMINS_CREATION = "admins_creation",
	ADMIN_CREATION = "admin_creation",
	SUBSCRIPTIONS = "subscriptions",
	SUBSCRIPTION = "subscription",
	NOTIFICATIONS = "notifications",
	NOTIFICATION = "notification",
	SPECIFIC_NOTIFICATIONS = "specific_notiifcations",
	SPECIFIC_NOTIFICATION = "specific_notiifcation",
	SCHEDULE_NOTIFICATIONS = "schedule_notifications",
	SCHEDULE_NOTIFICATION = "schedule_notification",
	COUNTRIES_EXPANSION = "countries_expansion",
	COUNTRY_EXPANSION = "country_expansion",
	PLAYER_ACCOUNTS_MANAGEMENT = "player_accounts_management",
	PLAYER_ACCOUNT_MANAGEMENT = "player_account_management",
	FEED_AREA = "feed_area",
	SINGLE_FEED_AREA = "single_feed_area",
	CLUBS_AMATEUR = "clubs_amateur",
	CLUB_AMATEUR_SINGLE = "club_amateur_single",
	CLUB_AMATEUR_USERS = "club_amateur_users",
	CLUB_AMATEUR_USER_DIRECTORS = "club_amateur_user_directors",
	CLUB_AMATEUR_USER_DIRECTOR = "club_amateur_user_director",
	CLUB_AMATEUR_USER_COACHS = "club_amateur_user_coachs",
	CLUB_AMATEUR_USER_COACH = "club_amateur_user_coach",
	CLUB_AMATEUR_TEAMS = "club_amateur_teams",
	CLUB_AMATEUR_TEAM = "club_amateur_team",
	CLUB_AMATEUR_TEAM_PLAYERS = "club_amateur_team_players",
	CLUB_AMATEUR_TEAM_PLAYER = "club_amateur_team_player",
	CLUB_AMATEUR_GAMES = "club_amateur_games",
	CLUB_AMATEUR_GAME = "club_amateur_game",
	GAME_UPLOADS = "game_uploads",
	GAME_UPLOAD_SINGLE = "game_upload_single",
	CLUBS_PRO = "clubs_pro",
	CLUB_PRO_SINGLE = "clubs_pro_single",
	CLUB_PRO_USERS = "clubs_pro_users",
	CLUB_PRO_USER_DIRECTOR = "club_pro_user_director",
}

export enum Permission {
	READ = "read",
	LIST = "list",
	CREATE = "create",
	EDIT = "edit",
	DELETE = "delete",
	GAME_VIP = "game_vip",
	GAME_HIDDEN = "game_hidden",
}
